import { useState, useEffect } from 'react'
import { Undo2 } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useUiStore } from '@/stores/uiStore'

const UNDO_DURATION_MS = 30000

export function UndoBar() {
  const { undoActions, executeUndo, removeUndoAction } = useUiStore()
  const [countdowns, setCountdowns] = useState<Record<string, number>>({})

  useEffect(() => {
    if (undoActions.length === 0) return

    const interval = setInterval(() => {
      const now = Date.now()
      const newCountdowns: Record<string, number> = {}

      for (const action of undoActions) {
        const remaining = Math.max(0, UNDO_DURATION_MS - (now - action.timestamp))
        if (remaining === 0) {
          removeUndoAction(action.id)
        } else {
          newCountdowns[action.id] = Math.ceil(remaining / 1000)
        }
      }

      setCountdowns(newCountdowns)
    }, 1000)

    return () => clearInterval(interval)
  }, [undoActions, removeUndoAction])

  if (undoActions.length === 0) return null

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 flex flex-col gap-2" aria-live="polite">
      {undoActions.map((action) => (
        <div
          key={action.id}
          className="flex items-center gap-3 px-4 py-2.5 rounded-lg bg-primary text-primary-foreground shadow-lg animate-in slide-in-from-bottom-2 duration-200"
        >
          <span className="text-sm">{action.summary}</span>
          <span className="text-xs opacity-70 tabular-nums min-w-[2ch]">
            {countdowns[action.id] ?? 30}s
          </span>
          <Button
            variant="secondary"
            size="sm"
            className="h-7 text-xs gap-1 bg-primary-foreground/20 hover:bg-primary-foreground/30 text-primary-foreground"
            onClick={() => executeUndo(action.id)}
          >
            <Undo2 className="h-3 w-3" />
            Undo
          </Button>
        </div>
      ))}
    </div>
  )
}
